import { OfferNetworkProvider } from "@redotech/crdb-enums/marketing/offer-network-provider";
import { ResolvedOfferConfig } from "@redotech/order-tracking-common/offer-network/offer-placement";
import { assertNever } from "@redotech/util/type";
import { mountFalconPlacement } from "./falcon-adapter";
import { OfferNetworkAttributes } from "./offer-attributes";
import { OfferPlacementHandle } from "./offer-placement";
import { mountRoktPlacement } from "./rokt-adapter";
import { mountUptickPlacement } from "./uptick-adapter";

export async function mountOfferPlacement(params: {
  config: ResolvedOfferConfig;
  attributes: OfferNetworkAttributes;
  container: HTMLElement;
}): Promise<OfferPlacementHandle> {
  const { config, attributes, container } = params;
  switch (config.provider) {
    case OfferNetworkProvider.Rokt:
      return mountRoktPlacement(config, attributes);
    case OfferNetworkProvider.Falcon:
      return mountFalconPlacement(config, attributes, container);
    case OfferNetworkProvider.Uptick:
      return mountUptickPlacement(config, attributes, container);
    default:
      assertNever(config);
  }
}
